var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityEventIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.000000pt",
    height: "22.000000pt",
    viewBox: "0 0 15.000000 22.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,22.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 212 c-41 -9 -59 -69 -31 -107 19 -26 81 -26 101 1 40 53 -3 120 -70 106z m61 -37 c29 -45 -5 -85 -61 -71 -51 13 -33 96 20 96 15 0 31 -10 41 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 176 c-6 -8 -10 -25 -8 -38 2 -18 9 -23 33 -23 24 0 31 5 33 24 3 15 -3 30 -14 38 -23 17 -29 16 -44 -1z m45 -38 c-8 -20 -42 -20 -42 0 0 9 5 21 11 28 13 14 38 -8 31 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 54 c-5 -15 -11 -30 -13 -33 -2 -3 9 -6 25 -6 26 0 29 3 29 33 0 40 -26 44 -41 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 48 c0 -30 3 -33 28 -33 28 0 29 1 16 30 -18 44 -44 46 -44 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityEventIcon);
export default __webpack_public_path__ + "static/media/QualityEventIcon.4aa0aa48dee2781a64de93ec4728abd1.svg";
export { ForwardRef as ReactComponent };